export default function truncateString(string, length = 350) {
  return string && string.length > length
    ? `${string.slice(0, length)}...`
    : string;
}
